import React from 'react';
import DefaultSwitchTenantPage from '@boilerplate/components/auth/DefaultSwitchTenantPage';

export default function SwitchTenantPage() {
  return <DefaultSwitchTenantPage redirect="/profile" label="Profile" />;
}
